import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IConsultAnonymousCardDataTableRowFormMeta {
  creationDate: FormInputMeta,
  prepaidProgram: FormInputMeta,
  cardNumber: FormInputMeta,
  effectiveDate: FormInputMeta,
  expirationDate: FormInputMeta,
  available: FormInputMeta,
  cardStatus: FormInputMeta,
  schema: any,
}

const ConsultAnonymousCardDataTableRowFormMeta = {} as IConsultAnonymousCardDataTableRowFormMeta;

ConsultAnonymousCardDataTableRowFormMeta.creationDate = {
  name: 'creationDate',
  type: 'date',
  label: 'Date Creation',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardDataTableRowFormMeta.prepaidProgram = {
  name: 'prepaidProgram',
  type: 'text',
  label: 'Prog.Prépayé',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardDataTableRowFormMeta.cardNumber = {
  name: 'cardNumber',
  type: 'text',
  label: 'Num Carte',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardDataTableRowFormMeta.effectiveDate = {
  name: 'effectiveDate',
  type: 'date',
  label: 'Date Effective',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardDataTableRowFormMeta.expirationDate = {
  name: 'expirationDate',
  type: 'date',
  label: 'Exp.',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardDataTableRowFormMeta.available = {
  name: 'available',
  type: 'text',
  label: 'Disponible',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardDataTableRowFormMeta.cardStatus = {
  name: 'cardStatus',
  type: 'text',
  label: 'Statut Carte',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ConsultAnonymousCardDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(ConsultAnonymousCardDataTableRowFormMeta));

export default ConsultAnonymousCardDataTableRowFormMeta;